import api from '../../index'

const {
  http,
  index
} = api

/**
 * ===================
 * JlptScoreLevel API
 * ===================
 */
export default {
  baseUrl: `${process.env.VUE_APP_CUSTOMER_URL}/api/v1`,
  url: 'jlpt-score-levels',
  http,
  index
}
